<template>
	<div>
		<div class="cooperation_banner">
			<div class="container">
				<div class="row">
					<h1 class="wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">服务商火热招募中
					</h1>
					<p class="wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
						领跑云打印行业，用智能让您一应俱全
						<!--  <span class="na_subtitle"></span> -->
					</p>
					<p class="wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
						<a class="btn btn-default btn-primary" href="javascript:void(0);" role="button"
							data-toggle="modal">成为代理商</a>
					</p>
					<div class="coopti2_bg wow fadeInUp animated" data-wow-delay="0.8s"
						style="visibility: visible; animation-delay: 0.8s; animation-name: fadeInUp;">
						<p class="tit_h1">
							低门槛
							<span>+</span>小投入
							<span>+</span>大市场
						</p>
						<p class="txt">
							<span>只要您愿意与我们共同发展</span>
							<span>成为代理商</span>
							<span>百亿级蓝海市场</span>
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="npagePage cooperation">
			<div class="cooperation_page3">
				<div class="container">
					<div class="clearfix row">
						<h3 class="header_title wow fadeInUp animated"
							style="visibility: visible; animation-name: fadeInUp;">
							<p class="title" style="color: #fff;">我们的优势</p>
						</h3>
					</div>
					<div class="clearfix row wow fadeInUp animated"
						style="margin-right: -30px; margin-left: -30px; margin-top: 50px; visibility: visible; animation-name: fadeInUp;">
						<div class="col-xs-6">
							<div class="clearfix row">
								<div class="col-xs-12 wow fadeInUp animated" data-wow-delay="0s"
									style="visibility: visible; animation-delay: 0s; animation-name: fadeInUp;">
									<div class="clearfix thumbnail_cont">
										<div class="title">市场领先优势</div>
										<div class="caption">众联云科技是国内最早的云打印服务提供商之一，客户遍布全国各地。</div>
									</div>
								</div>
								<div class="col-xs-12 wow fadeInUp animated" data-wow-delay="0.3s"
									style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;">
									<div class="clearfix thumbnail_cont">
										<div class="title">服务优势</div>
										<div class="caption">
											<div class="tc">
												<img src="/static/img/cooperation_page3_img1.jpg" alt />
											</div>
											<div class="tc">
												<br />厂家官方统一售后，快速响应，专业售后，代理无后顾之忧。
												<br />
												<br />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xs-6 wow fadeInUp animated" data-wow-delay="0.6s"
							style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInUp;">
							<div class="clearfix thumbnail_cont">
								<div class="title">产品优势</div>
								<div class="caption">
									<ul>
										<li>
											<i class="fa fa-check-square-o"></i>无需电脑、无需手机、无需驱动、无需人工，全自动接单。
										</li>
										<li>
											<i class="fa fa-check-square-o"></i>美团、饿了么、饿百多店铺全部自动接单。
										</li>
										<li>
											<i class="fa fa-check-square-o"></i>三重技术保障，彻底杜绝漏单。
										</li>
										<div class="caption_div">
											<p>一重保障：断电自动重打，防止因断电导致的漏单;</p>
											<p>二重保障：掉线自动换网，防止因设备掉线导致的漏单;</p>
											<p>三重保障：真人语音提醒，防止因人为原因导致的漏单。</p>
										</div>
										<li>
											<i class="fa fa-check-square-o"></i>高速打印头加自动切刀，高峰时段轻松应对。
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="col-xs-12 wow fadeInUp animated" data-wow-delay="0.9s"
							style="visibility: visible; animation-delay: 0.9s; animation-name: fadeInUp;">
							<div class="clearfix thumbnail_cont">
								<div class="title">众联云品牌优势</div>
								<div class="clearfix row advantage">
									<div class="col-my-20">
										<div class="thumbnail">
											<div class="page3_icon icon1"></div>
											<div class="tit tc">市场优势</div>
											<div class="caption">众联云科技是最早的外卖小票云打印服务提供商之一，客户遍布全国各地。</div>
										</div>
									</div>
									<div class="col-my-20">
										<div class="thumbnail">
											<div class="page3_icon icon2"></div>
											<div class="tit tc">技术领先</div>
											<div class="caption">软件、硬件均自主研发，坐享珠三角完整产业链支撑，确保技术持续领先市场。</div>
										</div>
									</div>
									<div class="col-my-20">
										<div class="thumbnail">
											<div class="page3_icon icon3"></div>
											<div class="tit tc">品质可靠</div>
											<div class="caption">自主工厂生产，12道工序严格检验，通过3C认证，质量可靠。</div>
										</div>
									</div>
									<div class="col-my-20">
										<div class="thumbnail">
											<div class="page3_icon icon4"></div>
											<div class="tit tc">服务高效</div>
											<div class="caption">专业售后，7*24快速响应。</div>
										</div>
									</div>
									<div class="col-my-20">
										<div class="thumbnail">
											<div class="page3_icon icon5"></div>
											<div class="tit tc">云端稳定</div>
											<div class="caption">采用腾讯云服务器，经过五年市场考验，性能稳定。</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="cooperation_page4">
				<div class="container">
					<div class="clearfix row">
						<h3 class="header_title wow fadeInUp animated"
							style="visibility: visible; animation-name: fadeInUp;">
							<p class="title" style="color:#fff;">代理政策</p>
						</h3>
					</div>
					<div class="clearfix row mt30">
						<div class="tit wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
							代理商应具备资源</div>
						<div class="page4_img wow fadeInUp animated"
							style="visibility: visible; animation-name: fadeInUp;">
							<img src="/static/img/cooppage4_img1.png" alt="自动接单打印机" />
						</div>
						<div class="tit wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
							众联云厂家给予八大支持</div>
						<div class="page4_img page4_img2 wow fadeInUp animated"
							style="visibility: visible; animation-name: fadeInUp; margin: 50px 120px;">
							<img src="/static/img/cooppage4_img2.png" alt="自动接单打印机" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
export default {
	data() { return {} }

}
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// shareContent.vue?bd10626c